export const validateEmailLocalPart = (
  localPart: string
): { isValid: boolean; error?: string } => {
  // Minimum only - the maximum is enforced on the full address by the callers,
  // which cap it at 75 characters.
  if (localPart.length < 2) {
    return {
      isValid: false,
      error: "Email username must be at least 2 characters long",
    };
  }

  // Check for leading/trailing spaces
  if (localPart.startsWith(" ") || localPart.endsWith(" ")) {
    return {
      isValid: false,
      error: "Email username cannot start or end with spaces",
    };
  }

  // Check for consecutive spaces
  if (localPart.includes("  ")) {
    return {
      isValid: false,
      error: "Email username cannot contain consecutive spaces",
    };
  }

  // Allowed characters regex - only permitting specified characters
  const allowedCharsRegex = /^[A-Za-z0-9\s._\-\'&(),:#@+]+$/;
  if (!allowedCharsRegex.test(localPart)) {
    return {
      isValid: false,
      error:
        "Only letters, numbers, spaces, and the following special characters are allowed: . - _ ' & ( ) , : # @ +",
    };
  }

  return { isValid: true };
};
